import axios from './axios';
import store from '../vuex';

// 根據當前登入狀況決定要呼叫哪一個 api 的方法
const getStreamingInfo = (roomId, currentLanguage) => {
  if (store.state.jwt) return getStreamingInfoAuthed(roomId, currentLanguage);
  else return getStreamingInfoUnauthed(roomId, currentLanguage);
};

// 不需要登入呼叫的 取得直播間資訊 api
const getStreamingInfoUnauthed = (roomId, currentLanguage) => {
  return axios.get(`/api/streaming/${roomId}`, {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

// 需要登入呼叫的 取得直播間資訊 api
const getStreamingInfoAuthed = (roomId, currentLanguage) => {
  return axios.get(`/api/streaming/authed/${roomId}`, {
    headers: {
      Authorization: `Bearer ${store.state.jwt}`,
      'Accept-Language': currentLanguage,
    },
  });
};

const getStreamingFallbackTicketProductId = (roomId, currentLanguage) => {
  return axios.get(`/api/streaming/${roomId}/fallbackTicketProductId`, {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

const getStreamingRoomByTicketId = (ticketId) => {
  return axios.get(`/api/streaming/ticket/streamingRoom?ticketId=${ticketId}`, {
    headers: {
      Authorization: `Bearer ${store.state.jwt}`,
    },
  });
};

const getVideoPlayUrl = (roomId, isSrcNeedAuth) => {
  if (isSrcNeedAuth) {
    return axios.get(`/api/streaming/${roomId}/authedPlayUrl`, {
      headers: {
        Authorization: `Bearer ${store.state.jwt}`,
      },
      withCredentials: true,
    });
  } else {
    return axios.get(`/api/streaming/${roomId}/playUrl`);
  }
};

const refreshVodToken = (roomId) => {
  return axios.get(`/api/streaming/${roomId}/refreshVodToken`, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${store.state.jwt}`,
    },
  });
};

const streamingGetChat = (cid, ts) => {
  return axios.get(`/api/streaming/${cid}/chat`, {
    params: { ts },
  });
};

const streamingGetSCMsg = (cid) => {
  return axios.get(`/api/streaming/${cid}/sc`, {});
};

const streamingPostMsg = (cid, data, jwt) => {
  return axios.post(
    `/api/streaming/${cid}/chat`,
    {
      msg: data.msg,
      sc: data.sc,
    },
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
  );
};

const getSCInfo = (currentLanguage) => {
  return axios.get('/api/system/scInfo', {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

const getUserItems = (jwt) => {
  return axios.get('/api/user/items', {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });
};

const checkPCLoginStatus = () => {
  return axios.get('/api/user/checkPCLoginStatus', {
    headers: {
      Authorization: `Bearer ${store.state.jwt}`,
    },
  });
};

const kickPCUser = () => {
  return axios.post(
    '/api/user/kickPCUser',
    {},
    {
      headers: {
        Authorization: `Bearer ${store.state.jwt}`,
      },
    },
  );
};

export {
  streamingGetChat,
  streamingGetSCMsg,
  streamingPostMsg,
  refreshVodToken,
  getSCInfo,
  getUserItems,
  getStreamingInfo,
  getStreamingRoomByTicketId,
  getStreamingFallbackTicketProductId,
  getVideoPlayUrl,
  kickPCUser,
  checkPCLoginStatus,
};
